export enum Domain {
  appDomain = 'appDomain',
  portalDomain = 'portalDomain',
}
